const blankToNull = require('./../../../utils').blankToNull;

export function validate(record){

    const errors = [];
    if (!record.nome || record.nome.trim().length < 4) {
        errors.push({ field: 'nome', message: 'O campo nome é obrigatório e deve ter mais de 3 caracteres' });
    }
    if (record.perfisAcaoSelecionados.length ===0) {
        errors.push({ field: 'nome', message: 'O campo Perfil é obrigatório' });
    }
    blankToNull(record);
    const result = {
        ok: errors.length === 0,
        errors,
        record
    }

    return new Promise((resolve, reject) => {
        const action = result.ok ? resolve : reject;
        return action(result);
    })
}